module.exports = __webpack_public_path__ + "static/media/grab_admin_url.d7960177.png";